import './App.css';
import React from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import * as Sentry from "@sentry/react";
import PrimeReact from 'primereact/api';


//import pages
import LogIn from "./components/auth/LogIn";
import ResetPassword from "./components/auth/ResetPassword";
import Home from './components/dashboard/Home';
import NoRolesHome from "./components/dashboard/NoRolesHome";
import Employers from './components/dashboard/employers/employers';
import Representatives from './components/dashboard/employers/representatives';
import EditRepresentative from './components/dashboard/employers/editRepresentative';
import EditEmployer from './components/dashboard/employers/editEmployer';
import PolicyHolders from "./components/dashboard/policy-holder/PolicyHolders";
import ViewPolicyHolder from "./components/dashboard/policy-holder/ViewPolicyHolder";
import ViewPolicyDetails from "./components/dashboard/policy-holder/ViewPolicyDetails";
import AddPolicyHolder from "./components/dashboard/policy-holder/addPolicyHolder";
import AllocatePolicy from "./components/dashboard/policy-holder/AllocatePolicy";
import Agents from './components/dashboard/agents/agents';
import AgentClients from "./components/dashboard/agents/agentClients";
import EditAgent from "./components/dashboard/agents/editAgent";
import Managers from './components/dashboard/managers/managers';
import EditManager from "./components/dashboard/managers/editManager";
import Policies from "./components/dashboard/policies/Policies";
import Users from './components/dashboard/users/Users';
import EditUser from './components/dashboard/users/EditUser';
import ViewUser from "./components/dashboard/users/ViewUser";
import Payments from './components/dashboard/payments/payments';
import Products from "./components/dashboard/products/Products";
import EditProduct from "./components/dashboard/products/EditProduct";
import Invoices from "./components/dashboard/invoice/Invoices";
import AllocateAccidentPolicy from "./components/dashboard/policy-holder/allocate-policy-forms/AllocateAccidentPolicy";
import AllocateFuneralPolicy from "./components/dashboard/policy-holder/allocate-policy-forms/AllocateFuneralPolicy";
import AllocateSavingsPolicy from "./components/dashboard/policy-holder/allocate-policy-forms/AllocateSavingsPolicy";
import AllocateComprehensivePolicy
    from "./components/dashboard/policy-holder/allocate-policy-forms/AllocateComprehensivePolicy";
import AllocateNhakaYangu from "./components/dashboard/policy-holder/allocate-policy-forms/AllocateNhakaYangu";
import EditAccidentPolicy from "./components/dashboard/policy-holder/edit-policy-forms/EditAccidentPolicy";
import EditFuneralPolicy from "./components/dashboard/policy-holder/edit-policy-forms/EditFuneralPolicy";
import EditSavingsPolicy from "./components/dashboard/policy-holder/edit-policy-forms/EditSavingsPolicy";
import EditComprehensivePolicy from "./components/dashboard/policy-holder/edit-policy-forms/EditComprehensivePolicy";
import EditNhakaYangu from "./components/dashboard/policy-holder/edit-policy-forms/EditNhakaYangu";
import ViewNhakaYangu from "./components/dashboard/policy-holder/ViewNhakaYangu";
import ViewPackages from "./components/dashboard/products/ViewPackages";
import ViewPfumaAccountPage from "./components/dashboard/policy-holder/ViewPfumaAccountPage";

/***
 * Settings routes
 */
import Settings from "./components/dashboard/settings/Settings";
import Permissions from "./components/dashboard/permissions/Permissions";
import ManagePermissions from "./components/dashboard/permissions/ManagePermissions";
import ViewPermissions from "./components/dashboard/permissions/ViewPermissions";
import AuditLog from "./components/dashboard/auditTrail/AuditLog";
import EditPolicyHolder from "./components/dashboard/policy-holder/EditPolicyHolder";
import BulkPayments from "./components/dashboard/payments/BulkPayments";
import AddPayment from "./components/dashboard/payments/AddPayment";
import AgeLimits from "./components/dashboard/settings/AgeLimits";
import PaymentMethods from "./components/dashboard/settings/PaymentMethods";
import SummaryToPrint from "./components/dashboard/policy-holder/SummaryToPrint";
import Teams from "./components/dashboard/settings/Teams";
import Channels from "./components/dashboard/settings/Channels";
import Positions from "./components/dashboard/settings/Positions";
import FormSettings from "./components/dashboard/settings/FormSettings";

/***
 * Commissions pages
 */
import Commissions from "./components/dashboard/commissions/Commissions";
import AccidentCommissions from "./components/dashboard/commissions/AccidentCommissions";
import FuneralCommissions from "./components/dashboard/commissions/FuneralCommissions";
import SavingsCommissions from "./components/dashboard/commissions/SavingsCommissions";
import ComprehensiveCommissions from "./components/dashboard/commissions/ComprehensiveCommissions";
import PfumaCommissions from "./components/dashboard/commissions/PfumaCommissions";

/***
 * End
 */
/***
 * Claims pages
 */
import Claims from "./components/dashboard/claims/Claims";
import ComprehensiveClaims from "./components/dashboard/claims/ComprehensiveClaims";
import FuneralClaims from "./components/dashboard/claims/FuneralClaims";
import AccidentClaims from "./components/dashboard/claims/AccidentClaims";
import SavingsClaims from "./components/dashboard/claims/SavingsClaims";
import InjuryClaims from "./components/dashboard/claims/InjuryClaims";
import DeathClaims from "./components/dashboard/claims/DeathClaims";
import SavingsDeathClaims from "./components/dashboard/claims/SavingsDeath";
import RefundClaims from "./components/dashboard/claims/Refund";
import SavingsSurrenders from "./components/dashboard/claims/Surrender";
import Withdrawals from "./components/dashboard/claims/PartialWithdrawal";
import PfumaClaims from "./components/dashboard/claims/PfumaClaims";
import InothoRefund from "./components/dashboard/claims/InothoRefund";
import InothoSurrender from "./components/dashboard/claims/InothoSurrender";
import InothoDeath from "./components/dashboard/claims/InothoDeath";
import InothoPartialWithdrawal from "./components/dashboard/claims/InothoPartialWithdrawal";
import InothoHospital from "./components/dashboard/claims/InothoHospital";
import InothoFuneral from "./components/dashboard/claims/InothoFuneral";
import InothoAccident from "./components/dashboard/claims/InothoAccident";
import InothoMaturity from "./components/dashboard/claims/InothoMaturity";
import SavingsMaturity from "./components/dashboard/claims/SavingsMaturity";

//forms
import AddAccidentClaims from "./components/dashboard/claims/forms/initiate_forms/addAccidentInjuryClaim";
import AddAccidentDeathClaim from "./components/dashboard/claims/forms/initiate_forms/addAccidentDeathClaim";
import AddComprehensiveClaim from "./components/dashboard/claims/forms/initiate_forms/addComprehensiveClaim";
import AddFuneralClaim from "./components/dashboard/claims/forms/initiate_forms/addFuneralClaim";
import AddSavingsDeathClaim from "./components/dashboard/claims/forms/initiate_forms/addSavingsDeathClaim";
import AddSavingsSurrender from "./components/dashboard/claims/forms/initiate_forms/addSavingsSurrender";
import AddRefundClaim from "./components/dashboard/claims/forms/initiate_forms/addRefundClaim";
import AddSavingsWithdrawal from "./components/dashboard/claims/forms/initiate_forms/addSavingsWithdrawal";
import AddInothoSurrender from "./components/dashboard/claims/forms/initiate_forms/addInothoSurrender";
import AddInothoWithdrawal from "./components/dashboard/claims/forms/initiate_forms/addInothoWithdrawal";
import AddInothoRefundClaim from "./components/dashboard/claims/forms/initiate_forms/addInothoRefundClaim";
import AddInothoDeathClaim from "./components/dashboard/claims/forms/initiate_forms/addInothoDeathClaim";
import AddInothoHospital from "./components/dashboard/claims/forms/initiate_forms/addInothoHospital";
import AddInothoFuneralClaim from "./components/dashboard/claims/forms/initiate_forms/addInothoFuneralClaim";
import AddInothoAccident from "./components/dashboard/claims/forms/initiate_forms/addInothoAccident";
import AddInothoMaturityClaim from "./components/dashboard/claims/forms/initiate_forms/addInothoMaturityClaim";
import AddSavingsMaturityClaim from "./components/dashboard/claims/forms/initiate_forms/addSavingsMaturityClaim";

import EditAccidentDeathClaim from "./components/dashboard/claims/forms/edit_forms/editAccidentDeathClaim";
import EditComprehensiveClaim from "./components/dashboard/claims/forms/edit_forms/editComprehensiveClaim";
import EditFuneralClaim from "./components/dashboard/claims/forms/edit_forms/editFuneralClaim";
import EditSavingsDeathClaim from "./components/dashboard/claims/forms/edit_forms/editSavingsDeathClaim";
import EditSavingsSurrender from "./components/dashboard/claims/forms/edit_forms/editSavingsSurrender";
import EditRefundClaim from "./components/dashboard/claims/forms/edit_forms/editRefundClaim";
import EditSavingsWithdrawal from "./components/dashboard/claims/forms/edit_forms/editSavingsWithdrawal";
import EditAccidentInjuryClaim from "./components/dashboard/claims/forms/edit_forms/editAccidentInjuryClaim";
import EditInothoSurrender from "./components/dashboard/claims/forms/edit_forms/editInothoSurrender";
import EditInothoWithdrawal from "./components/dashboard/claims/forms/edit_forms/editInothoWithdrawal";
import EditInothoRefundClaim from "./components/dashboard/claims/forms/edit_forms/editInothoRefundClaim";
import EditInothoDeathClaim from "./components/dashboard/claims/forms/edit_forms/editInothoDeathClaim";
import EditInothoHospital from "./components/dashboard/claims/forms/edit_forms/editInothoHospital";
import EditInothoFuneralClaim from "./components/dashboard/claims/forms/edit_forms/editInothoFuneralClaim";
import EditInothoAccident from "./components/dashboard/claims/forms/edit_forms/editInothoAccident";
import EditInothoMaturityClaim from "./components/dashboard/claims/forms/edit_forms/editInothoMaturityClaim";
import EditSavingsMaturityClaim from "./components/dashboard/claims/forms/edit_forms/editSavingsMaturityClaim";

import CommissionSettings from './components/dashboard/settings/commisions/index';
import Profile from "./components/dashboard/settings/Profile";
import SmsGateway from "./components/dashboard/settings/SmsGateway";
import EmailServer from "./components/dashboard/settings/EmailServer";
import ChangePassword from "./components/auth/ChangePassword";
import BeefPrice from "./components/dashboard/settings/BeefPrice";
import Industries from "./components/dashboard/settings/Industries";

/**
 * End claims
 */
/**
 * Reports
 */
import Reports from "./components/dashboard/reports/Reports";
import CommissionsReport from "./components/dashboard/reports/CommissionsReport";
import AccidentClaimsReport from "./components/dashboard/reports/AccidentClaimsReport";
import ClaimsPaidAnalysisReport from "./components/dashboard/reports/ClaimsPaidAnalysisReport";
import ComprehensiveClaimsReport from "./components/dashboard/reports/ComprehensiveClaimsReport";
import DeathClaimsReport from "./components/dashboard/reports/DeathClaimsReport";
import DeathClaimsPerProductReport from "./components/dashboard/reports/DeathClaimsPerProductReport";
import ExGratiaClaimsReport from "./components/dashboard/reports/ExGratiaClaimsReport";
import InvestmentsClaimsReport from "./components/dashboard/reports/InvestmentsClaimsReport";
import ListOfAccountsDocuments from "./components/dashboard/reports/ListOfAccountsDocuments";
import PaymentHistoryReport from "./components/dashboard/reports/PaymentHistoryReport";
import PremiumAnalysisByIndustryReport from "./components/dashboard/reports/PremiumAnalysisByIndustryReport";
import PremiumAnalysisByAggregatorReport from "./components/dashboard/reports/PremiumAnalysisByAggregatorReport";
import PremiumAnalysisByPolicyTypeReport from "./components/dashboard/reports/PremiumAnalysisByPolicyTypeReport";
import ReassuranceReport from "./components/dashboard/reports/ReassuranceReport";
import ReassuranceRecoveriesReport from "./components/dashboard/reports/ReassuranceRecoveriesReport";
import RevenueReport from "./components/dashboard/reports/RevenueReport";
import RiskProfilesReport from "./components/dashboard/reports/RiskProfilesReport";
import SavingsPoliciesDueToMatureReport from "./components/dashboard/reports/SavingsPoliciesDueToMatureReport";
import StandardFuneralClaimsReport from "./components/dashboard/reports/StandardFuneralClaimsReport";
import PolicyHoldersReport from "./components/dashboard/reports/PolicyHoldersReport";
import Alterations from "./components/dashboard/policy-holder/policies/Alterations";
import DeletedPoliciesReport from "./components/dashboard/reports/DeletedPoliciesReport";
import InothoClaimsReport from "./components/dashboard/reports/InothoClaimsReport";
import InothoPoliciesDueToMatureReport from "./components/dashboard/reports/InothoPoliciesDueToMatureReport";
import ClaimsTurnAroundReport from "./components/dashboard/reports/ClaimsTurnAroundReport";

/**
 * End Reports
 */


function App() {

    PrimeReact.ripple = true;
    PrimeReact.inputStyle = 'filled';
    PrimeReact.autoZIndex = true;
    PrimeReact.cssTransition = false; // Default value is true.
    PrimeReact.nullSortOrder = -1; // Default value is 1 for Excel like sorting.

    return (
        <div>
            <BrowserRouter>
                <Switch>
                    <Route exact path={['/', '/login']} component={LogIn}/>
                    <Route path={'/reset-password'} component={ResetPassword}/>
                    <Route path={'/change-password'} component={ChangePassword}/>
                    <Route path={'/dashboard'} component={Home}/>
                    <Route path={'/home'} component={NoRolesHome}/>
                    {/*            audit routes*/}
                    <Route path={'/log'} component={AuditLog}/>

                    {/*    claims*/}
                    <Route path={'/claims'} component={Claims}/>
                    <Route path={'/accident-claims'} component={AccidentClaims}/>
                    <Route path={'/accident-death-claims'} component={DeathClaims}/>
                    <Route path={'/accident-injury-claims'} component={InjuryClaims}/>
                    <Route path={'/comprehensive-claims'} component={ComprehensiveClaims}/>
                    <Route path={'/funeral-claims'} component={FuneralClaims}/>
                    <Route path={'/savings-claims'} component={SavingsClaims}/>
                    <Route path={'/savings-death-claims'} component={SavingsDeathClaims}/>
                    <Route path={'/savings-refunds'} component={RefundClaims}/>
                    <Route path={'/savings-surrenders'} component={SavingsSurrenders}/>
                    <Route path={'/savings-withdrawals'} component={Withdrawals}/>
                    <Route path={'/savings-maturity'} component={SavingsMaturity} />
                    <Route path={'/pfuma-claims'} component={PfumaClaims} />
                    <Route path={'/inotho-refunds'} component={InothoRefund} />
                    <Route path={'/inotho-deaths'} component={InothoDeath} />
                    <Route path={'/inotho-surrenders'} component={InothoSurrender} />
                    <Route path={'/inotho-withdrawals'} component={InothoPartialWithdrawal} />
                    <Route path={'/inotho-hospital'} component={InothoHospital} />
                    <Route path={'/inotho-accident'} component={InothoAccident} />
                    <Route path={'/inotho-funeral'} component={InothoFuneral} />
                    <Route path={'/inotho-maturity'} component={InothoMaturity} />

                    <Route path={'/add-accident-injury-claim'} component={AddAccidentClaims}/>
                    <Route path={'/add-accident-death-claim'} component={AddAccidentDeathClaim}/>
                    <Route path={'/add-comprehensive-claim'} component={AddComprehensiveClaim}/>
                    <Route path={'/add-funeral-claim'} component={AddFuneralClaim}/>
                    <Route path={'/add-savings-death-claim'} component={AddSavingsDeathClaim}/>
                    <Route path={'/add-refund'} component={AddRefundClaim}/>
                    <Route path={'/add-savings-surrender'} component={AddSavingsSurrender}/>
                    <Route path={'/add-partial-withdrawal'} component={AddSavingsWithdrawal}/>
                    <Route path={'/add-inotho-death-claim'} component={AddInothoDeathClaim} />
                    <Route path={'/add-inotho-refund'} component={AddInothoRefundClaim} />
                    <Route path={'/add-inotho-withdrawal'} component={AddInothoWithdrawal} />
                    <Route path={'/add-inotho-surrender'} component={AddInothoSurrender} />
                    <Route path={'/add-inotho-accident'} component={AddInothoAccident} />
                    <Route path={'/add-inotho-funeral'} component={AddInothoFuneralClaim} />
                    <Route path={'/add-inotho-hospital'} component={AddInothoHospital} />
                    <Route path={'/add-inotho-maturity'} component={AddInothoMaturityClaim} />
                    <Route path={'/add-savings-maturity'} component={AddSavingsMaturityClaim} />

                    {/*        edit claims*/}
                    <Route path={'/edit-accident-injury-claim'} component={EditAccidentInjuryClaim}/>
                    <Route path={'/edit-accident-death-claim'} component={EditAccidentDeathClaim}/>
                    <Route path={'/edit-comprehensive-claim'} component={EditComprehensiveClaim}/>
                    <Route path={'/edit-funeral-claim'} component={EditFuneralClaim}/>
                    <Route path={'/edit-savings-death-claim'} component={EditSavingsDeathClaim}/>
                    <Route path={'/edit-refund'} component={EditRefundClaim}/>
                    <Route path={'/edit-savings-surrender'} component={EditSavingsSurrender}/>
                    <Route path={'/edit-partial-withdrawal'} component={EditSavingsWithdrawal}/>
                    <Route path={'/edit-inotho-death-claim'} component={EditInothoDeathClaim} />
                    <Route path={'/edit-inotho-refund'} component={EditInothoRefundClaim} />
                    <Route path={'/edit-inotho-withdrawal'} component={EditInothoWithdrawal} />
                    <Route path={'/edit-inotho-surrender'} component={EditInothoSurrender} />
                    <Route path={'/edit-inotho-accident'} component={EditInothoAccident} />
                    <Route path={'/edit-inotho-funeral'} component={EditInothoFuneralClaim} />
                    <Route path={'/edit-inotho-hospital'} component={EditInothoHospital} />
                    <Route path={'/edit-inotho-maturity'} component={EditInothoMaturityClaim} />
                    <Route path={'/edit-savings-maturity'} component={EditSavingsMaturityClaim} />

                    {/*        end claims*/}

                    { /*employer & representative routes*/}
                    <Route path={'/employers'} component={Employers}/>
                    <Route path={'/representatives'} component={Representatives}/>
                    <Route path={'/edit-employer'} component={EditEmployer}/>
                    <Route path={'/edit-representative'} component={EditRepresentative}/>
                    { /*    policyHolder routes*/}
                    <Route path={'/policy-holders'} component={PolicyHolders}/>
                    <Route path = { '/view-policy-holder' } component = { ViewPolicyHolder }/>
                    <Route path={'/add-policy-holder'} component={AddPolicyHolder}/>
                    <Route path={'/edit-policy-holder'} component={EditPolicyHolder}/>
                    <Route path={'/allocate-policy'} component={AllocatePolicy}/>
                    <Route path={'/alterations'} component={Alterations}/>

                    {/*View Policy Routes*/}
                    <Route path={'/view-policy'} component={ViewPolicyDetails}/>
                    <Route path={'/summary'} component={SummaryToPrint} />
                    { /*    agents routes*/ }
                    <Route path = { '/agents' } component = { Agents }/>
                    <Route  path={'/agent-clients'} component={AgentClients}/>
                    <Route path={'/edit-agent'} component={EditAgent} />
                    { /*    managers routes*/ }
                    <Route path = { '/managers' } component = { Managers }/>
                    <Route path={'/edit-manager'} component={EditManager}/>
                    { /*    policies / clients*/}
                    <Route path={'/policies'} component={Policies}/>
                    {/* Products */}
                    <Route path={'/products'} component={Products}/>
                    <Route path={'/edit-product'} component={EditProduct}/>
                    <Route path={'/view-packages'} component={ViewPackages}/>

                    {/* All Users */}
                    <Route path={'/users'} component={Users}/>
                    <Route path={'/edit-user'} component={EditUser}/>
                    <Route path={'/view-user'} component={ViewUser}/>
                    {/* Payments Routes */}
                    <Route path={'/payments'} component={Payments}/>
                    <Route path={'/add-payment'} component={AddPayment}/>
                    <Route path={'/bulk-payments'} component={BulkPayments}/>
                    {/* Invoices */}
                    <Route path={'/invoice'} component={Invoices}/>
                    {/* Allocate Policy Forms Routes */}
                    <Route path={'/allocate-accident'} component={AllocateAccidentPolicy}/>
                    <Route path={'/allocate-funeral'} component={AllocateFuneralPolicy}/>
                    <Route path={'/allocate-savings'} component={AllocateSavingsPolicy}/>
                    <Route path={'/allocate-comprehensive'} component={AllocateComprehensivePolicy}/>
                    <Route path={'/allocate-ilifa'} component={AllocateNhakaYangu}/>
                    {/* Edit Policy Forms Routes */}
                    <Route path={'/edit-accident'} component={EditAccidentPolicy}/>
                    <Route path={'/edit-funeral'} component={EditFuneralPolicy}/>
                    <Route path={'/edit-savings'} component={EditSavingsPolicy}/>
                    <Route path={'/edit-comprehensive'} component={EditComprehensivePolicy}/>
                    <Route path={'/edit-ilifa'} component={EditNhakaYangu}/>
                    <Route path={'/view-ilifa'} component={ViewNhakaYangu}/>
                    <Route path={'/view-account'} component={ViewPfumaAccountPage}/>
                    {/*Permissions Routes*/}
                    <Route path={'/roles'} component={ViewPermissions}/>
                    <Route path={'/permissions'} component={ManagePermissions}/>
                    <Route path={'/view-permissions'} component={Permissions}/>
                    {/*    Commissions*/}
                    <Route path={'/commissions'} component={Commissions}/>
                    <Route path={'/accident-commissions'} component={AccidentCommissions}/>
                    <Route path={'/funeral-commissions'} component={FuneralCommissions}/>
                    <Route path={'/comprehensive-commissions'} component={ComprehensiveCommissions}/>
                    <Route path={'/savings-commissions'} component={SavingsCommissions}/>
                    <Route path={'/pfuma-commissions'} component={PfumaCommissions} />

                    {/*    settings */}
                    <Route path={'/commissions-settings'} component={CommissionSettings}/>
                    <Route path={'/profile'} component={Profile}/>
                    <Route path={'/sms-gateway'} component={SmsGateway}/>
                    <Route path={'/mail-server'} component={EmailServer}/>
                    <Route path={'/settings'} component={Settings}/>
                    <Route path={'/age-limits'} component={AgeLimits}/>
                    <Route path={'/payment-methods'} component={PaymentMethods}/>
                    <Route path={'/teams'} component={Teams}/>
                    <Route path={'/channels'} component={Channels}/>
                    <Route path={'/positions'} component={Positions}/> />
                    <Route path={'/beef-price-management'} component={BeefPrice}/>
                    <Route path={'/industries'} component={Industries}/>
                    <Route path={'/form-settings'} component={FormSettings}/>
                    {/*    Reports*/}
                    <Route path={'/reports'} component={Reports}/>
                    <Route path={'/commission-reports'} component={CommissionsReport}/>
                    <Route path={'/accident-claims-report'} component={AccidentClaimsReport}/>
                    <Route path={'/claims-paid-analysis'} component={ClaimsPaidAnalysisReport}/>
                    <Route path={'/claims-turn-around'} component={ClaimsTurnAroundReport}/>
                    <Route path={'/comprehensive-claims-report'} component={ComprehensiveClaimsReport}/>
                    <Route path={'/death-claims-report'} component={DeathClaimsReport}/>
                    <Route path={'/death-claims-per-product'} component={DeathClaimsPerProductReport}/>
                    <Route path={'/ex-gratia-claims'} component={ExGratiaClaimsReport}/>
                    <Route path={'/investment-claims'} component={InvestmentsClaimsReport}/>
                    <Route path={'/inotho-claims'} component={InothoClaimsReport}/>
                    <Route path={'/list-of-accounts'} component={ListOfAccountsDocuments}/>
                    <Route path={'/payment-history'} component={PaymentHistoryReport}/>
                    <Route path={'/premium-analysis-by-aggregator'} component={PremiumAnalysisByAggregatorReport}/>
                    <Route path={'/premium-analysis-by-industry'} component={PremiumAnalysisByIndustryReport}/>
                    <Route path={'/premium-analysis-by-policy-type'} component={PremiumAnalysisByPolicyTypeReport}/>
                    <Route path={'/reassurance-recoveries'} component={ReassuranceRecoveriesReport} />
                    <Route path={'/reassurance'} component={ReassuranceReport} />
                    <Route path={'/revenue-report'} component={RevenueReport} />
                    <Route path={'/risk-profiles'} component={RiskProfilesReport} />
                    <Route path={'/savings-policies-due-to-mature'} component={SavingsPoliciesDueToMatureReport} />
                    <Route path={'/standard-funeral-claims-report'} component={StandardFuneralClaimsReport}/>
                    <Route path={'/leads'} component={PolicyHoldersReport}/>
                    <Route path={'/deleted_policies'} component={DeletedPoliciesReport}/>
                    <Route path={'/inotho-policies-due-to-mature'} component={InothoPoliciesDueToMatureReport}/>

                </Switch>
        </BrowserRouter>
        </div>
    );
}

export default Sentry.withProfiler(App);
